export const PRIVACY_POLICY = 'privacyPolicy';
export const TERMS_AND_CONDITION = 'termsAndCondition';
export const defaultMicrosoftVoice = 'en-IN-AaravNeural';
export const defaultDeepGramVoice = 'aura-2-amalthea-en';
// export const emptyTranscriptText = "Okay, I didn't hear from you.";
export const emptyTranscriptText = 'Okay';
export const irrelevantText = 'No worries!';
export const FACE_DETECTION_TEXTS = {
    ORANGE_TEXTS: [
        'The lighting is too dim. Please move to a brighter area',
        'The lighting is too bright. Adjust your position or lighting',
        'Keep your face centered within the oval',
        'Ensure your face stays completely inside the oval',
        'Please keep your face straight and centered',
    ],
    RED_TEXTS: ['Please ensure your face is visible in the frame', 'Multiple faces are present in the frame'],
};
export const microsoftAudios = ['en-IN-AaravNeural', 'en-GB-RyanNeural', 'en-US-AvaNeural'];
export const deepGramAudios = [
    'aura-2-ophelia-en',
    'aura-2-aurora-en',
    'aura-2-delia-en',
    'aura-2-hyperion-en',
    'aura-2-juno-en',
    'aura-2-pluto-en',
    'aura-2-vesta-en',
];
export const maleVoices = new Set(['en-IN-AaravNeural', 'en-GB-RyanNeural', 'aura-2-hyperion-en', 'aura-2-pluto-en']);
export const azureLanguageVoiceMapping = {
    Bulgarian: { locale: 'bg-BG', female_voice: 'bg-BG-KalinaNeural', male_voice: 'bg-BG-BorislavNeural' },
    Catalan: { locale: 'ca-ES', female_voice: 'ca-ES-JoanaNeural', male_voice: 'ca-ES-EnricNeural' },
    'Chinese (Mandarin, Simplified)': {
        locale: 'zh-CN',
        female_voice: 'zh-CN-XiaochenMultilingualNeural',
        male_voice: 'zh-CN-YunxiaoMultilingualNeural',
    },
    'Chinese (Mandarin, Traditional)': {
        locale: 'zh-TW',
        female_voice: 'zh-TW-HsiaoChenNeural',
        male_voice: 'zh-TW-YunJheNeural',
    },
    'Chinese (Cantonese, Traditional)': {
        locale: 'zh-HK',
        female_voice: 'zh-HK-HiuMaanNeural',
        male_voice: 'zh-HK-WanLungNeural',
    },
    Czech: { locale: 'cs-CZ', female_voice: 'cs-CZ-VlastaNeural', male_voice: 'cs-CZ-AntoninNeural' },
    Danish: { locale: 'da-DK', female_voice: 'da-DK-ChristelNeural', male_voice: 'da-DK-JeppeNeural' },
    Dutch: { locale: 'nl-NL', female_voice: 'nl-NL-FennaNeural', male_voice: 'nl-NL-MaartenNeural' },
    English: {
        locale: 'en-US',
        female_voice: 'en-US-AvaMultilingualNeural',
        male_voice: 'en-US-AndrewMultilingualNeural',
    },
    Estonian: { locale: 'et-EE', female_voice: 'et-EE-AnuNeural', male_voice: 'et-EE-KertNeural' },
    Finnish: { locale: 'fi-FI', female_voice: 'fi-FI-SelmaNeural', male_voice: 'fi-FI-HarriNeural' },
    Flemish: { locale: 'nl-BE', female_voice: 'nl-BE-DenaNeural', male_voice: 'nl-BE-ArnaudNeural' },
    French: {
        locale: 'fr-FR',
        female_voice: 'fr-FR-VivienneMultilingualNeural',
        male_voice: 'fr-FR-RemyMultilingualNeural',
    },
    German: {
        locale: 'de-DE',
        female_voice: 'de-DE-SeraphinaMultilingualNeural',
        male_voice: 'de-DE-FlorianMultilingualNeural',
    },
    'German (Switzerland)': { locale: 'de-CH', female_voice: 'de-CH-LeniNeural', male_voice: 'de-CH-JanNeural' },
    Greek: { locale: 'el-GR', female_voice: 'el-GR-AthinaNeural', male_voice: 'el-GR-NestorasNeural' },
    Hindi: { locale: 'hi-IN', female_voice: 'hi-IN-AnanyaNeural', male_voice: 'hi-IN-AaravNeural' },
    Hungarian: { locale: 'hu-HU', female_voice: 'hu-HU-NoemiNeural', male_voice: 'hu-HU-TamasNeural' },
    Indonesian: { locale: 'id-ID', female_voice: 'id-ID-GadisNeural', male_voice: 'id-ID-ArdiNeural' },
    Italian: {
        locale: 'it-IT',
        female_voice: 'it-IT-IsabellaMultilingualNeural',
        male_voice: 'it-IT-AlessioMultilingualNeural',
    },
    Japanese: { locale: 'ja-JP', female_voice: 'ja-JP-NanamiNeural', male_voice: 'ja-JP-MasaruMultilingualNeural' },
    Korean: { locale: 'ko-KR', female_voice: 'ko-KR-SunHiNeural', male_voice: 'ko-KR-HyunsuMultilingualNeural' },
    Norwegian: { locale: 'nb-NO', female_voice: 'nb-NO-PernilleNeural', male_voice: 'nb-NO-FinnNeural' },
    Polish: { locale: 'pl-PL', female_voice: 'pl-PL-AgnieszkaNeural', male_voice: 'pl-PL-MarekNeural' },
    'Portuguese (Brazil)': {
        locale: 'pt-BR',
        female_voice: 'pt-BR-ThalitaMultilingualNeural',
        male_voice: 'pt-BR-MacerioMultilingualNeural',
    },
    'Portuguese (Portugal)': { locale: 'pt-PT', female_voice: 'pt-PT-RaquelNeural', male_voice: 'pt-PT-DuarteNeural' },
    Romanian: { locale: 'ro-RO', female_voice: 'ro-RO-AlinaNeural', male_voice: 'ro-RO-EmilNeural' },
    Russian: { locale: 'ru-RU', female_voice: 'ru-RU-SvetlanaNeural', male_voice: 'ru-RU-DmitryNeural' },
    Slovak: { locale: 'sk-SK', female_voice: 'sk-SK-ViktoriaNeural', male_voice: 'sk-SK-LukasNeural' },
    Spanish: {
        locale: 'es-ES',
        female_voice: 'es-ES-ArabellaMultilingualNeural',
        male_voice: 'es-ES-TristanMultilingualNeural',
    },
    Swedish: { locale: 'sv-SE', female_voice: 'sv-SE-SofieNeural', male_voice: 'sv-SE-MattiasNeural' },
    Turkish: { locale: 'tr-TR', female_voice: 'tr-TR-EmelNeural', male_voice: 'tr-TR-AhmetNeural' },
    Ukrainian: { locale: 'uk-UA', female_voice: 'uk-UA-PolinaNeural', male_voice: 'uk-UA-OstapNeural' },
    Vietnamese: { locale: 'vi-VN', female_voice: 'vi-VN-HoaiMyNeural', male_voice: 'vi-VN-NamMinhNeural' },
    Bengali: { locale: 'bn-IN', female_voice: 'bn-IN-TanishaaNeural', male_voice: 'bn-IN-BashkarNeural' },
    Tamil: { locale: 'ta-IN', female_voice: 'ta-IN-PallaviNeural', male_voice: 'ta-IN-ValluvarNeural' },
    Telugu: { locale: 'te-IN', female_voice: 'te-IN-ShrutiNeural', male_voice: 'te-IN-MohanNeural' },
    Gujarati: { locale: 'gu-IN', female_voice: 'gu-IN-DhwaniNeural', male_voice: 'gu-IN-NiranjanNeural' },
    Kannada: { locale: 'kn-IN', female_voice: 'kn-IN-SapnaNeural', male_voice: 'kn-IN-GaganNeural' },
    Malayalam: { locale: 'ml-IN', female_voice: 'ml-IN-SobhanaNeural', male_voice: 'ml-IN-MidhunNeural' },
    Marathi: { locale: 'mr-IN', female_voice: 'mr-IN-AarohiNeural', male_voice: 'mr-IN-ManoharNeural' },
    Punjabi: { locale: 'pa-IN', female_voice: 'pa-IN-VaaniNeural', male_voice: 'pa-IN-OjasNeural' },
};

export const REGIONAL_LANGUAGES = [
    'Bengali',
    'Tamil',
    'Telugu',
    'Gujarati',
    'Kannada',
    'Malayalam',
    'Marathi',
    'Punjabi',
    'Hindi',
];

export const INTERNATIONAL_LANGUAGES = [
    'Bulgarian',
    'Catalan',
    'Chinese (Mandarin, Simplified)',
    'Chinese (Mandarin, Traditional)',
    'Chinese (Cantonese, Traditional)',
    'Czech',
    'Danish',
    'Dutch',
    'English',
    'Estonian',
    'Finnish',
    'Flemish',
    'French',
    'German',
    'German (Switzerland)',
    'Greek',
    'Hindi',
    'Hungarian',
    'Indonesian',
    'Italian',
    'Japanese',
    'Korean',
    'Norwegian',
    'Polish',
    'Portuguese (Brazil)',
    'Portuguese (Portugal)',
    'Romanian',
    'Russian',
    'Slovak',
    'Spanish',
    'Swedish',
    'Turkish',
    'Ukrainian',
    'Vietnamese',
];

export const language_mapping = {
    Bulgarian: {
        deepgram: 'bg',
        azure: '',
        gladia: 'bg',
        start: 'Здравейте, благодаря ви, че се присъединихте днес. Нека започнем. Първо, бихте ли споделили малко за себе си?',
        resuming:
            'Здравейте отново на интервюто. Нека продължим от там, където спряхме миналия път. Можете ли да потвърдите, когато сте готов?',
        end: 'Обсъдихме всички теми, необходими за оценка на вашите знания. Благодаря ви за отделеното време и желая ви успешен и приятен ден!',
    },
    Catalan: {
        deepgram: 'ca',
        azure: 'ca-ES',
        gladia: 'ca',
        start: 'Hola, gràcies per unir-vos avui. Comencem. Per començar, podríeu explicar-nos una mica sobre vosaltres?',
        resuming:
            'Hola de nou a l’entrevista. Comencem des d’on ho vam deixar l’última vegada. Pots confirmar quan estiguis llest?',
        end: 'Hem tractat tots els temes necessaris per valorar els teus coneixements. Gràcies pel teu temps i et desitjo que tinguis un dia excel·lent!',
    },
    'Chinese (Mandarin, Simplified)': {
        deepgram: 'zh',
        azure: 'zh-CN',
        gladia: 'zh',
        start: '你好，谢谢你今天的加入。我们开始吧。首先，请简单介绍一下你自己？',
        resuming: '你好，欢迎回到面试。我们从上次中断的地方继续。准备好后请确认一下。',
        end: '我们已经涵盖了评估您知识所需的所有主题。感谢您抽出时间，祝您度过美好的一天！',
    },
    'Chinese (Mandarin, Traditional)': {
        deepgram: 'zh-TW',
        azure: 'zh-TW',
        gladia: 'zh-TW',
        start: '您好，感謝您今天的參與。我們開始吧。首先，請簡單介紹一下自己？',
        resuming: '您好，歡迎回到面試。我們從上次中斷的地方繼續。準備好後請確認一下。',
        end: '我們已經完整涵蓋了評估您知識所需的所有主題。感謝您的寶貴時間，祝您有美好的一天！',
    },
    'Chinese (Cantonese, Traditional)': {
        deepgram: 'zh-HK',
        azure: 'zh-HK',
        gladia: 'yue',
        start: '你好，謝謝你今天加入。我哋而家開始。首先，可唔可以簡單介紹下自己？',
        resuming: '你好，歡迎返嚟面試。我哋由上次停嘅地方繼續。準備好嘅話可唔可以確認下？',
        end: '我哋已經涵蓋咗所有需要用嚟評估你知識嘅主題。多謝你抽時間參與，祝你有愉快嘅一日！',
    },
    Czech: {
        deepgram: 'cs',
        azure: '',
        gladia: 'cs',
        start: 'Ahoj, děkujeme, že jste se dnes připojili. Pojďme začít. Mohl byste nám prosím říci něco o sobě?',
        resuming:
            'Ahoj, vítejte zpět na pohovoru. Začneme tam, kde jsme skončili naposledy. Můžete potvrdit, až budete připraven?',
        end: 'Probrali jsme všechna témata potřebná k posouzení vašich znalostí. Děkujeme za váš čas a přejeme vám příjemný den!',
    },
    Danish: {
        deepgram: 'da',
        azure: 'da-DK',
        gladia: 'da',
        start: 'Hej, tak fordi du deltager i dag. Lad os komme i gang. Kan du starte med at fortælle lidt om dig selv?',
        resuming:
            'Hej, velkommen tilbage til interviewet. Lad os fortsætte der, hvor vi slap sidst. Kan du bekræfte, når du er klar?',
        end: 'Vi har gennemgået alle de emner, der er nødvendige for at vurdere din viden. Mange tak for din tid, og jeg ønsker dig en fortsat god dag!',
    },
    Dutch: {
        deepgram: 'nl',
        azure: 'nl-NL',
        gladia: 'nl',
        start: 'Hallo, bedankt dat je er vandaag bij bent. Laten we beginnen. Kun je eerst iets over jezelf vertellen?',
        resuming:
            'Hoi, welkom terug bij het interview. Laten we verder gaan waar we de vorige keer stopten. Kun je bevestigen wanneer je klaar bent?',
        end: 'We hebben alle onderwerpen besproken die nodig zijn om je kennis te beoordelen. Hartelijk dank voor je tijd en ik wens je een fijne dag verder!',
    },
    English: {
        deepgram: 'en',
        azure: 'en-US',
        gladia: 'en',
        start: "Hi, thank you for joining today. Let's get started. To begin with, could you please tell me a bit about yourself?",
        resuming:
            "Hi, welcome back to the interview. Let's begin the interview from the point where we left the last time. Can you confirm once you are ready?",
        end: 'We’ve covered all the topics needed to assess your knowledge thoroughly. Thank you for dedicating your valuable time today, and I wish you a pleasant and successful day ahead!',
    },
    Estonian: {
        deepgram: 'et',
        azure: '',
        gladia: 'et',
        start: 'Tere, aitäh, et liitusite täna. Alustame. Kas te saaksite esmalt natuke endast rääkida?',
        resuming:
            'Tere tulemast tagasi intervjuusse. Alustame sealt, kus viimati lõpetasime. Kas saate kinnitada, kui olete valmis?',
        end: 'Oleme käsitlenud kõiki teemasid, mis on vajalikud teie teadmiste hindamiseks. Täname teid aja eest ja soovime teile ilusat päeva!',
    },
    Finnish: {
        deepgram: 'fi',
        azure: 'fi-FI',
        gladia: 'fi',
        start: 'Hei, kiitos että liityit tänään mukaan. Aloitetaan. Voisitko ensin kertoa hieman itsestäsi?',
        resuming:
            'Hei, tervetuloa takaisin haastatteluun. Aloitetaan siitä, mihin jäimme viimeksi. Voitko vahvistaa, kun olet valmis?',
        end: 'Olemme käyneet läpi kaikki aihealueet, joita tarvitaan osaamisesi arvioimiseksi. Kiitos ajastasi ja toivotan sinulle oikein hyvää päivää!',
    },
    Flemish: {
        deepgram: 'nl-BE',
        azure: '',
        gladia: 'nl-BE',
        start: 'Hallo, bedankt dat je vandaag aanwezig bent. Laten we beginnen. Kun je eerst iets over jezelf vertellen?',
        resuming:
            'Hoi, welkom terug bij het interview. Laten we verder gaan waar we de vorige keer stopten. Kun je bevestigen wanneer je klaar bent?',
        end: 'We hebben alle onderwerpen besproken die nodig zijn om je kennis goed te beoordelen. Dank je wel voor je tijd en nog een fijne dag gewenst!',
    },
    French: {
        deepgram: 'fr',
        azure: 'fr-FR',
        gladia: 'fr',
        start: 'Bonjour, merci de nous rejoindre aujourd’hui. Commençons. Pour commencer, pourriez-vous nous dire un peu sur vous ?',
        resuming:
            'Bonjour et bienvenue pour cette reprise de l’entretien. Reprenons là où nous nous sommes arrêtés la dernière fois. Pouvez-vous confirmer quand vous êtes prêt ?',
        end: 'Nous avons couvert tous les sujets nécessaires pour évaluer vos connaissances. Merci pour votre temps et je vous souhaite une excellente journée!',
    },
    German: {
        deepgram: 'de',
        azure: 'de-DE',
        gladia: 'de',
        start: 'Hallo, danke, dass Sie heute dabei sind. Lassen Sie uns beginnen. Erzählen Sie uns bitte zunächst etwas über sich.',
        resuming:
            'Hallo und willkommen zurück zum Interview. Lassen Sie uns dort weitermachen, wo wir beim letzten Mal aufgehört haben. Können Sie bestätigen, wenn Sie bereit sind?',
        end: 'Wir haben alle Themen behandelt, die für die Beurteilung Ihres Wissens erforderlich sind. Vielen Dank für Ihre Zeit und ich wünsche Ihnen einen angenehmen Tag!',
    },
    'German (Switzerland)': {
        deepgram: 'de-CH',
        azure: '',
        gladia: 'de-CH',
        start: 'Grüezi, merci dass Sie heute dabei sind. Lass uns starten. Erzähl etwas über dich.',
        resuming:
            'Grüezi und willkommen zurück zum Interview. Lass uns dort weitermachen, wo wir das letzte Mal aufgehört haben. Kannst du bestätigen, wenn du bereit bist?',
        end: 'Wir haben alle wichtigen Themen behandelt, um dein Wissen einzuschätzen. Vielen Dank für deine Zeit und hab noch einen schönen Tag!',
    },
    Greek: {
        deepgram: 'el',
        azure: '',
        gladia: 'el',
        start: 'Γεια σας, ευχαριστούμε που συμμετείχατε σήμερα. Ας ξεκινήσουμε. Μπορείτε να μας πείτε λίγα λόγια για εσάς;',
        resuming:
            'Γεια σας και καλώς ήρθατε ξανά στη συνέντευξη. Ας συνεχίσουμε από εκεί που σταματήσαμε την τελευταία φορά. Μπορείτε να επιβεβαιώσετε όταν είστε έτοιμος;',
        end: 'Καλύψαμε όλα τα θέματα που χρειάζονται για την αξιολόγηση των γνώσεών σας. Σας ευχαριστούμε για τον χρόνο σας και σας ευχόμαστε μια υπέροχη μέρα!',
    },
    Hindi: {
        deepgram: 'hi',
        azure: 'hi-IN',
        gladia: 'hi',
        start: 'नमस्ते, आज जुड़ने के लिए धन्यवाद। चलिए शुरू करते हैं। शुरुआत में, क्या आप अपने बारे में थोड़ा बता सकते हैं?',
        resuming:
            'नमस्ते, इंटरव्यू में आपका फिर से स्वागत है। चलिए वहीं से शुरू करते हैं जहाँ हम पिछली बार रुके थे। जब आप तैयार हों, कृपया पुष्टि करें।',
        end: 'हमने आपके ज्ञान का आकलन करने के लिए सभी आवश्यक विषयों को कवर कर लिया है। आपके समय के लिए धन्यवाद और आपको शुभ दिन की शुभकामनाएँ!',
    },
    Hungarian: {
        deepgram: 'hu',
        azure: 'hu-HU',
        gladia: 'hu',
        start: 'Szia, köszönjük, hogy ma csatlakoztál. Kezdjük el. Először is, mesélnél egy kicsit magadról?',
        resuming:
            'Szia, üdv újra az interjún. Folytassuk onnan, ahol legutóbb abbahagytuk. Meg tudod erősíteni, ha készen állsz?',
        end: 'Áttekintettük az összes szükséges témát a tudásod értékeléséhez. Köszönjük az idődet, és további szép napot kívánunk!',
    },
    Indonesian: {
        deepgram: 'id',
        azure: 'id-ID',
        gladia: 'id',
        start: 'Halo, terima kasih telah bergabung hari ini. Mari kita mulai. Untuk memulainya, bisakah Anda ceritakan sedikit tentang diri Anda?',
        resuming:
            'Halo, selamat datang kembali di wawancara. Mari kita lanjutkan dari titik terakhir kita berhenti. Bisa konfirmasi jika Anda sudah siap?',
        end: 'Kami telah membahas semua topik yang diperlukan untuk menilai pengetahuan Anda. Terima kasih atas waktu Anda. Semoga harimu menyenangkan!',
    },
    Italian: {
        deepgram: 'it',
        azure: 'it-IT',
        gladia: 'it',
        start: "Ciao, grazie per esserti unito oggi. Iniziamo. Per cominciare, potresti parlarci un po' di te?",
        resuming:
            'Ciao, bentornato al colloquio. Riprendiamo da dove ci eravamo fermati l’ultima volta. Puoi confermare quando sei pronto?',
        end: 'Abbiamo trattato tutti gli argomenti necessari per valutare le tue conoscenze. Grazie per il tuo tempo. Ti auguro una splendida giornata!',
    },
    Japanese: {
        deepgram: 'ja',
        azure: 'ja-JP',
        gladia: 'ja',
        start: 'こんにちは。本日はご参加いただきありがとうございます。さっそく始めましょう。まずは自己紹介をお願いできますか？',
        resuming:
            'こんにちは。面接に戻っていただきありがとうございます。前回中断したところから再開しましょう。準備ができたら教えていただけますか？',
        end: '知識を評価するために必要なすべてのトピックを網羅しました。お時間をいただきありがとうございました。良い一日をお過ごしください！',
    },
    Korean: {
        deepgram: 'ko',
        azure: 'ko-KR',
        gladia: 'ko',
        start: '안녕하세요. 오늘 참여해 주셔서 감사합니다. 시작하겠습니다. 먼저 자기소개를 부탁드려도 될까요?',
        resuming:
            '안녕하세요. 다시 면접에 오신 것을 환영합니다. 지난번에 중단한 부분부터 시작하겠습니다. 준비되시면 알려주시겠습니까?',
        end: '지식을 평가하는 데 필요한 모든 주제를 다루었습니다. 시간을 내주셔서 감사합니다. 좋은 하루 보내시길 바랍니다!',
    },
    Norwegian: {
        deepgram: 'no',
        azure: 'nb-NO',
        gladia: 'no',
        start: 'Hei, takk for at du ble med i dag. La oss starte. Kan du først fortelle litt om deg selv?',
        resuming:
            'Hei, velkommen tilbake til intervjuet. La oss fortsette fra der vi stoppet sist. Kan du bekrefte når du er klar?',
        end: 'Vi har gått gjennom alle temaene som er nødvendige for å vurdere kunnskapen din. Tusen takk for tiden din. Ha en flott dag videre!',
    },
    Polish: {
        deepgram: 'pl',
        azure: 'pl-PL',
        gladia: 'pl',
        start: 'Cześć, dziękujemy, że dołączyłeś dzisiaj. Zaczynajmy. Na początek, czy możesz opowiedzieć nam trochę o sobie?',
        resuming:
            'Cześć, witaj ponownie na rozmowie. Zacznijmy od miejsca, w którym skończyliśmy ostatnio. Czy możesz potwierdzić, kiedy będziesz gotowy?',
        end: 'Omówiliśmy wszystkie tematy potrzebne do oceny twojej wiedzy. Dziękujemy za poświęcony czas. Życzymy miłego dnia!',
    },
    'Portuguese (Brazil)': {
        deepgram: 'pt',
        azure: 'pt-BR',
        gladia: 'pt',
        start: 'Olá, obrigado por participar hoje. Vamos começar. Para começar, você poderia falar um pouco sobre você?',
        resuming:
            'Olá, bem-vindo de volta à entrevista. Vamos continuar de onde paramos da última vez. Pode confirmar quando estiver pronto?',
        end: 'Cobrimos todos os tópicos necessários para avaliar seu conhecimento. Obrigado pelo seu tempo. Desejo-lhe um ótimo dia!',
    },
    'Portuguese (Portugal)': {
        deepgram: 'pt-PT',
        azure: 'pt-PT',
        gladia: 'pt-PT',
        start: 'Olá, obrigado por se juntar hoje. Vamos começar. Para começar, pode falar-nos um pouco sobre si?',
        resuming:
            'Olá, bem-vindo de volta à entrevista. Vamos retomar do ponto onde parámos da última vez. Pode confirmar quando estiver pronto?',
        end: 'Abordámos todos os tópicos necessários para avaliar o seu conhecimento. Obrigado pelo seu tempo. Desejo-lhe um excelente dia!',
    },
    Romanian: {
        deepgram: 'ro',
        azure: 'ro-RO',
        gladia: 'ro',
        start: 'Bună, îți mulțumim că te-ai alăturat astăzi. Hai să începem. Pentru început, ne poți spune câteva lucruri despre tine?',
        resuming:
            'Bună, bine ai revenit la interviu. Să continuăm de unde am rămas ultima dată. Poți confirma când ești gata?',
        end: 'Am acoperit toate subiectele necesare pentru a-ți evalua cunoștințele. Îți mulțumim pentru timpul acordat. Îți dorim o zi frumoasă!',
    },
    Russian: {
        deepgram: 'ru',
        azure: 'ru-RU',
        gladia: 'ru',
        start: 'Здравствуйте, спасибо, что присъединились сегодня. Давайте начнем. Для начала, расскажите немного о себе?',
        resuming:
            'Здравствуйте, добро пожаловать снова на интервью. Давайте продолжим с того места, где остановились в прошлый раз. Подтвердите, когда будете готовы.',
        end: 'Мы обсудили все темы, необходимые для оценки ваших знаний. Спасибо за ваше время. Желаем вам отличного дня!',
    },
    Slovak: {
        deepgram: 'sk',
        azure: '',
        gladia: 'sk',
        start: 'Ahoj, ďakujeme, že si sa dnes pripojil. Začnime. Môžeš nám na úvod povedať niečo o sebe?',
        resuming:
            'Ahoj, vitaj späť na pohovore. Začnime tam, kde sme minule skončili. Môžeš potvrdiť, keď budeš pripravený?',
        end: 'Prešli sme všetky témy potrebné na posúdenie tvojich vedomostí. Ďakujeme za tvoj čas. Prajeme ti pekný deň!',
    },
    Spanish: {
        deepgram: 'es',
        azure: 'es-ES',
        gladia: 'es',
        start: 'Hola, gracias por unirte hoy. Empecemos. Para comenzar, ¿podrías contarnos un poco sobre ti?',
        resuming:
            'Hola, bienvenido de nuevo a la entrevista. Continuemos desde donde lo dejamos la última vez. ¿Puedes confirmar cuando estés listo?',
        end: 'Hemos cubierto todos los temas necesarios para evaluar tus conocimientos. Gracias por tu tiempo. ¡Que tengas un excelente día!',
    },
    Swedish: {
        deepgram: 'sv',
        azure: 'sv-SE',
        gladia: 'sv',
        start: 'Hej, tack för att du är med idag. Låt oss börja. Kan du först berätta lite om dig själv?',
        resuming:
            'Hej, välkommen tillbaka till intervjun. Låt oss fortsätta från där vi slutade sist. Kan du bekräfta när du är redo?',
        end: 'Vi har gått igenom alla ämnen som behövs för att bedöma dina kunskaper. Tack för din tid. Ha en fortsatt trevlig dag!',
    },
    Turkish: {
        deepgram: 'tr',
        azure: 'tr-TR',
        gladia: 'tr',
        start: 'Merhaba, bugün bize katıldığınız için teşekkür ederiz. Hadi başlayalım. Öncelikle biraz kendinizden bahseder misiniz?',
        resuming:
            'Merhaba, mülakata tekrar hoş geldiniz. Geçen sefer bıraktığımız yerden devam edelim. Hazır olduğunuzda onaylar mısınız?',
        end: 'Bilginizi değerlendirmek için gerekli tüm konuları ele aldık. Vaktiniz için teşekkür ederiz. Size harika bir gün dileriz!',
    },
    Ukrainian: {
        deepgram: 'uk',
        azure: 'uk-UA',
        gladia: 'uk',
        start: 'Привіт, дякуємо, що приєдналися сьогодні. Давайте почнемо. Для початку, розкажіть трохи про себе?',
        resuming:
            'Привіт, ласкаво просимо назад на співбесіду. Давайте продовжимо з того місця, де ми зупинилися минулого разу. Підтвердіть, коли будете готові.',
        end: 'Ми обговорили всі теми, необхідні для оцінки ваших знань. Дякуємо за ваш час. Бажаємо гарного дня!',
    },
    Vietnamese: {
        deepgram: 'vi',
        azure: 'vi-VN',
        gladia: 'vi',
        start: 'Xin chào, cảm ơn bạn đã tham gia hôm nay. Chúng ta hãy bắt đầu. Trước tiên, bạn có thể giới thiệu một chút về bản thân mình được không?',
        resuming:
            'Xin chào, chào mừng bạn quay lại buổi phỏng vấn. Chúng ta sẽ tiếp tục từ điểm đã dừng lần trước. Bạn có thể xác nhận khi nào sẵn sàng chứ?',
        end: 'Chúng ta đã trao đổi đầy đủ các chủ đề cần thiết để đánh giá kiến thức của bạn. Cảm ơn bạn đã dành thời gian tham gia. Chúc bạn một ngày tốt lành!',
    },

    Bengali: {
        sarvam: 'bn-IN',
        gladia: 'bn',
        start: 'নমস্কার, আজ যোগ দেওয়ার জন্য ধন্যবাদ। চলুন শুরু করি। প্রথমেই, আপনি কি একটু নিজের সম্পর্কে বলতে পারেন?',
        resuming:
            'নমস্কার, সাক্ষাৎকারে আবার স্বাগতম। চলুন আমরা যেখানে শেষ করেছিলাম সেখান থেকে শুরু করি। আপনি প্রস্তুত হলে জানাবেন।',
        end: 'আমরা আপনার জ্ঞান মূল্যায়নের জন্য প্রয়োজনীয় সমস্ত বিষয় কভার করেছি। আজ আপনার মূল্যবান সময় দেওয়ার জন্য ধন্যবাদ। আপনার আগামীর জন্য শুভেচ্ছা রইল!',
    },
    Tamil: {
        sarvam: 'ta-IN',
        gladia: 'ta',
        start: 'வணக்கம், இன்று கலந்து கொண்டதற்கு நன்றி. தொடங்கலாம். முதலில், தயவுசெய்து உங்களைப் பற்றிச் சிறிது சொல்ல முடியுமா?',
        resuming:
            'வணக்கம், நேர்முகத் தேர்வில் மீண்டும் வருகைக்கு நன்றி. நாம் கடந்த முறை நிறுத்திய இடத்தில் இருந்து தொடங்கலாம். தயார் என்றால் தெரியப்படுத்துங்கள்.',
        end: 'உங்கள் அறிவை மதிப்பிட தேவையான அனைத்து தலைப்புகளையும் நாங்கள் கவர் செய்துள்ளோம். இன்று உங்கள் மதிப்புமிக்க நேரத்தை ஒதுக்கியதற்கு நன்றி. உங்கள் எதிர்காலம் சிறப்பாக அமைய வாழ்த்துக்கள்!',
    },
    Telugu: {
        sarvam: 'te-IN',
        gladia: 'te',
        start: 'నమస్తే, ఈ రోజు పాల్గొన్నందుకు ధన్యవాదాలు. ప్రారంభిద్దాం. ముందు, మీ గురించి కొంచెం చెప్పగలరా?',
        resuming:
            'నమస్తే, ఇంటర్వ్యూకి తిరిగి స్వాగతం. మనం గత సారి ఆపిన చోట నుంచి ప్రారంభిద్దాం. మీరు సిద్ధంగా ఉన్నప్పుడు దయచేసి తెలియజేయండి.',
        end: 'మీ పరిజ్ఞానాన్ని అంచనా వేసేందుకు అవసరమైన అన్ని అంశాలను మేము కవర్ చేశాము. ఈ రోజు మీ విలువైన సమయాన్ని కేటాయించినందుకు ధన్యవాదాలు. మీ భవిష్యత్తు విజయవంతం కావాలని కోరుకుంటున్నాము!',
    },
    Gujarati: {
        sarvam: 'gu-IN',
        gladia: 'gu',
        start: 'નમસ્તે, આજે જોડાવા બદલ આભાર. ચાલો શરૂ કરીએ. સૌ પ્રથમ, શું તમે તમારા વિશે થોડી માહિતી આપી શકો છો?',
        resuming:
            'નમસ્તે, ઇન્ટરવ્યુમાં ફરીથી સ્વાગત છે. ચાલો જ્યાંથી છેલ્લે છોડી હતી ત્યાંથી શરૂ કરીએ. તમે તૈયાર હો ત્યારે જણાવો.',
        end: 'અમે તમારા જ્ઞાનનું મૂલ્યાંકન કરવા માટે જરૂરી તમામ વિષયો આવરી લીધા છે. આજે તમારો કિંમતી સમય આપવા બદલ આભાર. તમારી ભવિષ્યની સફળતા માટે શુભેચ્છાઓ!',
    },
    Kannada: {
        sarvam: 'kn-IN',
        gladia: 'kn',
        start: 'ನಮಸ್ಕಾರ, ಇಂದು ಸೇರಿಕೊಂಡಿದ್ದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ಪ್ರಾರಂಭಿಸೋಣ. ಮೊದಲು, ನಿಮ್ಮ ಬಗ್ಗೆ ಸ್ವಲ್ಪ ಹೇಳಬಹುದಾ?',
        resuming:
            'ನಮಸ್ಕಾರ, ಸಂದರ್ಶನಕ್ಕೆ ಮತ್ತೆ ಸ್ವಾಗತ. ನಾವು ಕಳೆದ ಬಾರಿ ನಿಲ್ಲಿಸಿದ ಸ್ಥಳದಿಂದ ಪ್ರಾರಂಭಿಸೋಣ. ನೀವು ಸಿದ್ಧರಾಗಿದ್ದರೆ ದಯವಿಟ್ಟು ತಿಳಿಸಿ.',
        end: 'ನಿಮ್ಮ ಜ್ಞಾನವನ್ನು ಮೌಲ್ಯಮಾಪನ ಮಾಡಲು ಅಗತ್ಯವಿರುವ ಎಲ್ಲಾ ವಿಷಯಗಳನ್ನು ನಾವು ಒಳಗೊಂಡಿದ್ದೇವೆ. ಇಂದು ನಿಮ್ಮ ಅಮೂಲ್ಯ ಸಮಯ ನೀಡಿದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು. ನಿಮ್ಮ ಭವಿಷ್ಯ ಯಶಸ್ವಿಯಾಗಲಿ!',
    },
    Malayalam: {
        sarvam: 'ml-IN',
        gladia: 'ml',
        start: 'നമസ്കാരം, ഇന്ന് പങ്കെടുത്തതിന് നന്ദി. തുടങ്ങാം. ആദ്യം, നിങ്ങളുടെ കുറിച്ച് കുറച്ച് പറയാമോ?',
        resuming:
            'നമസ്കാരം, അഭിമുഖത്തിലേക്ക് വീണ്ടും സ്വാഗതം. കഴിഞ്ഞ തവണ നിർത്തിയിടത്തിൽ നിന്ന് തുടങ്ങാം. നിങ്ങൾ തയ്യാറായാൽ ദയവായി അറിയിക്കുക.',
        end: 'നിങ്ങളുടെ അറിവ് വിലയിരുത്തുന്നതിനായി ആവശ്യമായ എല്ലാ വിഷയങ്ങളും ഞങ്ങൾ ഉൾപ്പെടുത്തിയിട്ടുണ്ട്. ഇന്ന് നിങ്ങളുടെ വിലപ്പെട്ട സമയം നൽകിയതിന് നന്ദി. നിങ്ങളുടെ ഭാവിക്ക് എല്ലാ ആശംസകളും!',
    },
    Marathi: {
        sarvam: 'mr-IN',
        gladia: 'mr',
        start: 'नमस्कार, आज सामील झाल्याबद्दल धन्यवाद. चला सुरू करूया. प्रथम, कृपया तुमच्याबद्दल थोडेसे सांगू शकाल का?',
        resuming:
            'नमस्कार, मुलाखतीत पुन्हा स्वागत आहे. आपण मागच्या वेळी जिथे थांबलो तिथून सुरू करूया. तुम्ही तयार झाल्यावर कळवा.',
        end: 'आपल्या ज्ञानाचे मूल्यमापन करण्यासाठी आवश्यक असलेले सर्व विषय आपण झाकले आहेत. आज तुमचा मौल्यवान वेळ दिल्याबद्दल धन्यवाद. तुमच्या भविष्यासाठी शुभेच्छा!',
    },
    Punjabi: {
        sarvam: 'pa-IN',
        gladia: 'pa',
        start: 'ਸਤ ਸ੍ਰੀ ਅਕਾਲ, ਅੱਜ ਸ਼ਾਮਲ ਹੋਣ ਲਈ ਧੰਨਵਾਦ। ਆਓ ਸ਼ੁਰੂ ਕਰੀਏ। ਪਹਿਲਾਂ, ਕੀ ਤੁਸੀਂ ਆਪਣੇ ਬਾਰੇ ਕੁਝ ਦੱਸ ਸਕਦੇ ਹੋ?',
        resuming:
            'ਸਤ ਸ੍ਰੀ ਅਕਾਲ, ਇੰਟਰਵਿਊ ਵਿੱਚ ਵਾਪਸ ਸਵਾਗਤ ਹੈ। ਆਓ ਜਿੱਥੇ ਅਸੀਂ ਪਿਛਲੀ ਵਾਰ ਰੁਕੇ ਸੀ, ਉਥੋਂ ਸ਼ੁਰੂ ਕਰੀਏ। ਜਦੋਂ ਤੁਸੀਂ ਤਿਆਰ ਹੋ ਜਾਓ, ਦੱਸੋ।',
        end: 'ਅਸੀਂ ਤੁਹਾਡੇ ਗਿਆਨ ਦਾ ਮੁਲਾਂਕਣ ਕਰਨ ਲਈ ਸਾਰੇ ਜ਼ਰੂਰੀ ਵਿਸ਼ੇ ਕਵਰ ਕਰ ਲਏ ਹਨ। ਅੱਜ ਆਪਣਾ ਕੀਮਤੀ ਸਮਾਂ ਦੇਣ ਲਈ ਧੰਨਵਾਦ। ਤੁਹਾਨੂੰ ਭਵਿੱਖ ਲਈ ਸ਼ੁਭਕਾਮਨਾਵਾਂ!',
    },
};
